export const COMPANY_JURISDICTIONS = Object.freeze({
  EU: "EU",
  UK: "UK",
});
